import React from 'react';
import InformationHeader from '../../../component/reusable/informationHeader/InformationHeader';
import AddManufacturerForm from '../../../component/manufacturerComps/AddManufacturerForm';

const AddManufacturer = () => {


  return (
    <div style={{  }}>
      <InformationHeader mainpage="Dashboard" prevpage="Categories"  pagename="Add New Manufacturer" buttonText="Save"/>
      <AddManufacturerForm />
    </div>
  );
};

export default AddManufacturer;
